import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const MENU_GAP = 4;
const VIEW_PAD = 8;

function placeMenu(trigger, menu, align) {
  if (!trigger || !menu) return {};
  const rect = trigger.getBoundingClientRect();
  const width = menu.offsetWidth || 240;
  const height = menu.offsetHeight || 160;
  const rtl =
    document.documentElement.dir === "rtl" ||
    getComputedStyle(document.documentElement).direction === "rtl" ||
    getComputedStyle(trigger).direction === "rtl";
  const preferEnd = align === "end";
  let left = preferEnd
    ? rtl
      ? rect.left
      : rect.right - width
    : rtl
      ? rect.right - width
      : rect.left;
  let top = rect.bottom + MENU_GAP;
  const maxLeft = window.innerWidth - width - VIEW_PAD;
  const maxTop = window.innerHeight - height - VIEW_PAD;
  if (left < VIEW_PAD) left = VIEW_PAD;
  if (left > maxLeft) left = Math.max(VIEW_PAD, maxLeft);
  if (top > maxTop) {
    const above = rect.top - height - MENU_GAP;
    top = above >= VIEW_PAD ? above : Math.max(VIEW_PAD, maxTop);
  }
  return { position: "fixed", top, left, zIndex: 20000 };
}

export default function ParityMenu({
  trigger,
  children,
  align = "end",
  className = "",
  triggerClassName = "parity-row-menu-trigger",
  menuClassName = "parity-row-menu-list",
  label = "عملیات",
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const [style, setStyle] = useState({});

  useLayoutEffect(() => {
    if (!open) return;
    setStyle(placeMenu(triggerRef.current, menuRef.current, align));
  }, [open, align, children]);

  useEffect(() => {
    if (!open) return;
    const reposition = () => setStyle(placeMenu(triggerRef.current, menuRef.current, align));
    const onPointer = (event) => {
      if (
        triggerRef.current?.contains(event.target) ||
        menuRef.current?.contains(event.target)
      ) {
        return;
      }
      setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("resize", reposition);
    window.addEventListener("scroll", reposition, true);
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("touchstart", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("resize", reposition);
      window.removeEventListener("scroll", reposition, true);
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("touchstart", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, align]);

  return (
    <div className={`parity-row-menu-wrap ${className}`.trim()}>
      <button
        ref={triggerRef}
        type="button"
        className={triggerClassName}
        title={label}
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        {trigger}
      </button>
      {open &&
        ReactDOM.createPortal(
          <ul
            ref={menuRef}
            className={`${menuClassName} is-portal`}
            role="menu"
            style={style}
            onClick={() => setOpen(false)}
          >
            {children}
          </ul>,
          document.body
        )}
    </div>
  );
}
